const DOCUMENT_POSITION_PRECEDING = 2;
const DOCUMENT_POSITION_FOLLOWING = 4;

export function compareDocumentOrder(first?: Node, second?: Node): number {
	if(!first || !second || first === second) {
		return 0;
	}

	const position = first.compareDocumentPosition(second);
	if(position & DOCUMENT_POSITION_FOLLOWING) {
		return -1;
	}
	if(position & DOCUMENT_POSITION_PRECEDING) {
		return 1;
	}

	return 0;
}
